import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React, { useState, createContext } from 'react';
import { getLocaleFromUrl, localeToISO } from '../common/utils';

var noop = function noop() {
  return undefined;
};

export var LocalizationContext = createContext({
  locale: getLocaleFromUrl().locale,
  loading: true,
  setLocale: noop
});
var urlLocale = getLocaleFromUrl().locale;
export var LocalizationProvider = function LocalizationProvider(_ref) {
  var _ref$initialLocale = _ref.initialLocale,
      initialLocale = _ref$initialLocale === void 0 ? localeToISO(urlLocale) : _ref$initialLocale,
      onLocaleChanged = _ref.onLocaleChanged,
      fallback = _ref.fallback,
      children = _ref.children;

  var _useState = useState(initialLocale),
      _useState2 = _slicedToArray(_useState, 2),
      locale = _useState2[0],
      setLocale = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var handleChange = onLocaleChanged;
  var setLocaleInternal = React.useCallback(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(locale) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);

              if (!handleChange) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return handleChange(locale);

            case 4:
              setLocale(localeToISO(locale));
              setLoading(false);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [handleChange]);
  React.useEffect(function () {
    setLocaleInternal(locale);
  }, [locale, setLocaleInternal]);
  return ___EmotionJSX(LocalizationContext.Provider, {
    value: {
      locale: locale,
      setLocale: setLocaleInternal,
      loading: loading
    }
  }, loading && fallback ? fallback : children);
};